// extracted by mini-css-extract-plugin
export default {"cls1":"BulkFollowSuggestion-cls1__a599eac1ac9750370692","cls2":"BulkFollowSuggestion-cls2___b3b862030e2b9dacf64 BulkFollowSuggestion-cls1__a599eac1ac9750370692"};